<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center mb-3">
            <button type="button" class="bill-service__back-icon me-2" (click)="goBack()" aria-label="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <h4 class="mb-0">Nueva Factura (consolidada)</h4>
        </div>

        <!-- Paso 0 · Entidad que factura -->
        <div class="bill-service__step d-flex align-items-center">
            <span class="bill-service__step-circle">0</span>
            <span class="bill-service__step-label">Entidad que factura</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <label class="bill-service__field-label">Empresa que factura</label>
            <div class="bill-service__custom-select" [class.is-open]="billingEntityOpen">
                <button type="button" class="bill-service__custom-select-trigger" (click)="toggleBillingEntity()">
                    <span class="bill-service__custom-select-value" *ngIf="selectedBillingEntity; else phEntity">
                        <span class="bill-service__code-chip">{{ selectedBillingEntity.rfc }}</span>
                        <span>{{ selectedBillingEntity.name }}</span>
                    </span>
                    <ng-template #phEntity>
                        <span class="bill-service__custom-select-placeholder">Selecciona una entidad</span>
                    </ng-template>
                    <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                </button>
                <ul class="bill-service__custom-select-menu" *ngIf="billingEntityOpen">
                    <li *ngFor="let entity of billingEntities" class="bill-service__custom-select-option" (click)="selectBillingEntity(entity.id)">
                        <span class="bill-service__code-chip">{{ entity.rfc }}</span>
                        <span>{{ entity.name }}</span>
                    </li>
                </ul>
            </div>
            <div class="row mt-3">
                <div class="col-md-4">
                    <button type="button" class="btn btn-info btn-service btn-add w-100" style="background-color: #00A0E1; border-color: #00A0E1;" (click)="onAddBillingEntity()">
                        <i class="ti ti-plus"></i>
                        Agregar nueva entidad de factura
                    </button>
                </div>
            </div>
        </div>

        <!-- Paso 1 · Cliente receptor -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">1</span>
            <span class="bill-service__step-label">Cliente a facturar</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <label class="bill-service__field-label">Cliente</label>
            <div class="bill-service__custom-select" [class.is-open]="clientOpen">
                <button type="button" class="bill-service__custom-select-trigger" (click)="toggleClient()">
                    <span class="bill-service__custom-select-value" *ngIf="selectedClient; else phClient">
                        <span class="bill-service__code-chip">{{ selectedClient.rfc }}</span>
                        <span>{{ selectedClient.business_name || selectedClient.name }}</span>
                    </span>
                    <ng-template #phClient>
                        <span class="bill-service__custom-select-placeholder">Selecciona un cliente</span>
                    </ng-template>
                    <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                </button>
                <div class="bill-service__custom-select-menu bill-service__invoice-menu" *ngIf="clientOpen" (click)="$event.stopPropagation()">
                    <div class="bill-service__invoice-search">
                        <i class="ti ti-search bill-service__invoice-search-icon"></i>
                        <input type="text" class="bill-service__invoice-search-input" [(ngModel)]="clientSearchText"
                               placeholder="Buscar por razón social o RFC..." autocomplete="off">
                    </div>
                    <div class="bill-service__invoice-list">
                        <div *ngIf="filteredClients.length === 0" class="bill-service__custom-select-option text-muted">
                            Sin clientes
                        </div>
                        <div *ngFor="let c of filteredClients" class="bill-service__custom-select-option" (click)="selectClient(c)">
                            <span class="bill-service__code-chip">{{ c.rfc }}</span>
                            <span>{{ c.business_name || c.name }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row g-3 mt-2" *ngIf="selectedClient">
                <div class="col-md-4 col-sm-6">
                    <label class="bill-service__field-label">RFC</label>
                    <input type="text" class="form-control" [value]="rfc" readonly>
                </div>
                <div class="col-md-4 col-sm-6">
                    <label class="bill-service__field-label">Razón social</label>
                    <input type="text" class="form-control" [value]="razonSocial" readonly>
                </div>
                <div class="col-md-4 col-sm-6">
                    <label class="bill-service__field-label">Código postal</label>
                    <input type="text" class="form-control" [value]="codigoPostal" readonly>
                </div>
            </div>
        </div>

        <!-- Paso 2 · Configuración CFDI -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">2</span>
            <span class="bill-service__step-label">Configuración de CFDI</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="bill-service__field-label">Forma de Pago</label>
                    <div class="bill-service__custom-select" [class.is-open]="paymentFormOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="!isPaymentFormLocked && togglePaymentForm()" [disabled]="isPaymentFormLocked">
                            <span class="bill-service__custom-select-value" *ngIf="selectedPaymentForm; else phForm">
                                <span class="bill-service__code-chip">{{ selectedPaymentForm.key }}</span>
                                <span>{{ selectedPaymentForm.name }}</span>
                            </span>
                            <ng-template #phForm>
                                <span class="bill-service__custom-select-placeholder">Selecciona una forma de pago</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="paymentFormOpen">
                            <li *ngFor="let pf of paymentForms" class="bill-service__custom-select-option" (click)="selectPaymentForm(pf.key)">
                                <span class="bill-service__code-chip">{{ pf.key }}</span>
                                <span>{{ pf.name }}</span>
                            </li>
                        </ul>
                    </div>
                    <small class="text-muted" *ngIf="isPaymentFormLocked">Con método PPD la forma de pago debe ser 99 (Por definir).</small>
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Método de Pago</label>
                    <div class="bill-service__custom-select" [class.is-open]="paymentMethodOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="togglePaymentMethod()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedPaymentMethod; else phMethod">
                                <span class="bill-service__code-chip">{{ selectedPaymentMethod.key }}</span>
                                <span>{{ selectedPaymentMethod.name }}</span>
                            </span>
                            <ng-template #phMethod>
                                <span class="bill-service__custom-select-placeholder">Selecciona un método de pago</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="paymentMethodOpen">
                            <li *ngFor="let pm of paymentMethods" class="bill-service__custom-select-option" (click)="selectPaymentMethod(pm.key)">
                                <span class="bill-service__code-chip">{{ pm.key }}</span>
                                <span>{{ pm.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paso 3 · Servicios a facturar (consolidación) -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">3</span>
            <span class="bill-service__step-label">Servicios a facturar</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <div *ngIf="!selectedClient" class="text-muted">Selecciona primero un cliente para ver sus servicios sin facturar.</div>

            <div *ngIf="selectedClient">
                <label class="bill-service__field-label">Asociar servicios sin facturar</label>
                <div class="bill-service__custom-select" [class.is-open]="servicesOpen">
                    <button type="button" class="bill-service__custom-select-trigger" (click)="toggleServices()">
                        <span class="bill-service__custom-select-value" *ngIf="conceptItems.length > 0; else phServices">
                            <span>{{ conceptItems.length }} servicio{{ conceptItems.length === 1 ? '' : 's' }} seleccionado{{ conceptItems.length === 1 ? '' : 's' }}</span>
                        </span>
                        <ng-template #phServices>
                            <span class="bill-service__custom-select-placeholder">Selecciona servicios</span>
                        </ng-template>
                        <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                    </button>
                    <div class="bill-service__custom-select-menu bill-service__invoice-menu" *ngIf="servicesOpen" (click)="$event.stopPropagation()">
                        <div class="bill-service__invoice-list">
                            <div *ngIf="loadingServices" class="bill-service__custom-select-option text-muted">Cargando…</div>
                            <div *ngIf="!loadingServices && billableServices.length === 0" class="bill-service__custom-select-option text-muted">
                                Este cliente no tiene servicios sin facturar
                            </div>
                            <label *ngFor="let svc of billableServices"
                                   class="bill-service__invoice-option"
                                   [class.is-selected]="isServiceSelected(svc.id)">
                                <input type="checkbox" class="bill-service__invoice-checkbox"
                                       [checked]="isServiceSelected(svc.id)"
                                       (change)="toggleServiceSelection(svc)">
                                <span class="bill-service__code-chip">#{{ svc.folio ?? svc.id }}</span>
                                <span class="bill-service__invoice-option-text">
                                    {{ (svc.origin_address || '—') }} → {{ (svc.destination_address || '—') }}
                                    <ng-container *ngIf="svc.upload_date"> · {{ svc.upload_date }}</ng-container>
                                </span>
                            </label>
                        </div>
                        <div class="bill-service__invoice-confirm">
                            <button type="button" class="bill-service__invoice-confirm-btn" (click)="toggleServices()">
                                <i class="ti ti-check"></i> Listo
                                <span *ngIf="conceptItems.length > 0">({{ conceptItems.length }})</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Tabla de conceptos editables (uno por servicio) -->
                <div class="table-responsive mt-3" *ngIf="conceptItems.length > 0">
                    <table class="table table-sm align-middle">
                        <thead>
                            <tr>
                                <th>Servicio</th>
                                <th style="min-width: 180px;">Descripción</th>
                                <th>Cant.</th>
                                <th>Unidad</th>
                                <th>P. Unitario</th>
                                <th>Clave SAT</th>
                                <th>Impuesto</th>
                                <th class="text-end">Importe</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of conceptItems">
                                <td>
                                    <span class="bill-service__code-chip">#{{ item.folio ?? item.service_id }}</span>
                                    <div class="small text-muted" *ngIf="item.route">{{ item.route }}</div>
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [(ngModel)]="item.service_description" maxlength="900"></td>
                                <td><input type="number" min="0" step="1" class="form-control form-control-sm" style="width: 80px;" [(ngModel)]="item.quantity"></td>
                                <td>
                                    <select class="form-select form-select-sm" [(ngModel)]="item.unit_key">
                                        <option *ngFor="let u of units" [value]="u.key">{{ u.key }} · {{ u.name }}</option>
                                    </select>
                                </td>
                                <td><input type="number" min="0" step="0.01" class="form-control form-control-sm" style="width: 110px;" [(ngModel)]="item.unit_price"></td>
                                <td>
                                    <select class="form-select form-select-sm" [(ngModel)]="item.product_service_key">
                                        <option *ngFor="let p of productServiceKeys" [value]="p.key">{{ p.key }}</option>
                                    </select>
                                </td>
                                <td>
                                    <select class="form-select form-select-sm" [(ngModel)]="item.tax_object_key">
                                        <option *ngFor="let t of taxObjectOptions" [value]="t.key">{{ t.key }} · {{ t.name }}</option>
                                    </select>
                                </td>
                                <td class="text-end">${{ conceptSubtotal(item) | number:'1.2-2' }}</td>
                                <td>
                                    <button type="button" class="bill-service__upload-remove" (click)="removeConcept(item.service_id)" aria-label="Quitar">
                                        <i class="ti ti-x"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Totales -->
                <div class="bill-service__summary-panel mt-3" *ngIf="conceptItems.length > 0">
                    <div class="bill-service__summary-row">
                        <span class="bill-service__summary-label">Subtotal</span>
                        <span class="bill-service__summary-total">${{ subtotal | number:'1.2-2' }}</span>
                    </div>
                    <div class="bill-service__summary-row">
                        <span class="bill-service__summary-label">IVA (16%)</span>
                        <span class="bill-service__summary-total">${{ iva | number:'1.2-2' }}</span>
                    </div>
                    <div class="bill-service__summary-divider"></div>
                    <div class="bill-service__summary-row bill-service__summary-row--balance">
                        <span class="bill-service__summary-label">Total</span>
                        <span class="bill-service__summary-balance">${{ total | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bill-service__actions d-flex justify-content-center gap-3 mt-5">
            <button type="button" class="btn bill-service__btn-cancel" (click)="onCancel()" [disabled]="isGenerating">Cancelar</button>
            <button type="button" class="btn bill-service__btn-submit" (click)="onGenerateInvoice()" [disabled]="!isFormValid || isGenerating">
                <span *ngIf="!isGenerating">Generar factura</span>
                <span *ngIf="isGenerating"><i class="ti ti-loader bill-service__spin"></i> Generando…</span>
            </button>
        </div>
    </div>
</div>
